// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1HMk6","content":"RecentSearches_content__3IP2M"};